// @ts-expect-error - package has no type declarations
import googleTagLinker from "@analytics-debugger/google-tag-linker";

/**
 * Generates the GA4 `_gl` linker parameter and appends it to `url`.
 *
 * Must be called JUST BEFORE navigation — `_gl` contains a time-based fingerprint
 * hash with a ~2 min TTL, so it cannot be cached or pre-generated at render time.
 *
 * Use only for JS-driven cross-domain redirects (`window.location.href = ...`)
 * or OAuth flows where gtag auto-decoration won't kick in. For regular
 * `<a href>` clicks, gtag's linker config handles `_gl` automatically.
 */
export const decorateUrlWithGaLinker = (url: string): string => {
    if (typeof window === "undefined") {
        return url;
    }

    try {
        const gl = googleTagLinker("get") as string | undefined;
        if (!gl) {
            return url;
        }
        const parsed = new URL(url, window.location.origin);
        parsed.searchParams.set("_gl", gl);
        return parsed.toString();
    } catch {
        return url;
    }
};
// @ts-expect-error - package has no type declarations
import googleTagLinker from "@analytics-debugger/google-tag-linker";

/**
 * Generates the GA4 `_gl` linker parameter and appends it to `url`.
 *
 * Must be called JUST BEFORE navigation — `_gl` contains a time-based fingerprint
 * hash with a ~2 min TTL, so it cannot be cached or pre-generated at render time.
 *
 * Use only for JS-driven cross-domain redirects (`window.location.href = ...`)
 * or OAuth flows where gtag auto-decoration won't kick in. For regular
 * `<a href>` clicks, gtag's linker config handles `_gl` automatically.
 */
export const decorateUrlWithGaLinker = (url: string): string => {
    if (typeof window === "undefined") {
        return url;
    }

    try {
        const gl = googleTagLinker("get") as string | undefined;
        if (!gl) {
            return url;
        }
        const parsed = new URL(url, window.location.origin);
        parsed.searchParams.set("_gl", gl);
        return parsed.toString();
    } catch {
        return url;
    }
};
